import React from 'react';
import Body from './Body';
import H1 from './H1';
import H2 from './H2';
import H3 from './H3';
import H4 from './H4';
import H5 from './H5';
import Hero from './Hero';
import Paragraph from './Paragraph';
import SmallUppercase from './SmallUppercase';

const AccentHero = props => <Hero color="accent" {...props} />;
const AccentH1 = props => <H1 color="accent" {...props} />;
const AccentH2 = props => <H2 color="accent" {...props} />;
const AccentH3 = props => <H3 color="accent" {...props} />;
const AccentH4 = props => <H4 color="accent" {...props} />;
const AccentH5 = props => <H5 color="accent" {...props} />;

const SecondaryH1 = props => <H1 color="secondary" {...props} />;
const SecondaryH2 = props => <H2 color="secondary" {...props} />;
const SecondaryH3 = props => <H3 color="secondary" {...props} />;
const SecondaryH4 = props => <H4 color="secondary" {...props} />;
const SecondaryH5 = props => <H5 color="secondary" {...props} />;
const SecondaryBody = props => <Body color="secondary" {...props} />;

export {
  H1,
  H2,
  H3,
  H4,
  H5,
  Body,
  Paragraph,
  AccentHero,
  AccentH1,
  AccentH2,
  AccentH3,
  AccentH4,
  AccentH5,
  SecondaryH1,
  SecondaryH2,
  SecondaryH3,
  SecondaryH4,
  SecondaryH5,
  SecondaryBody,
  SmallUppercase
};
